var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-section',{attrs:{"id":"register-section","gap":"xl","gutter-y":"medium","gutter-x":"","contain":""}},[_c('SectionHeader',{attrs:{"title":_vm.$t('shop.registerTitle'),"description":_vm.$t('shop.registerDescription')}}),_vm._v(" "),_c('RegisterForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }